import { lazy } from "common/load/componentUtils";

import { CloseProp, useDrawer } from "client/common/hooks/stackables";

import type { OrderCancelationDrawerProps } from "../components/OrderCancelationDrawer";

const OrderCancelationDrawer = lazy(() => import("../components/OrderCancelationDrawer"));

export const useOrderCancelationDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: OrderCancelationDrawerProps & CloseProp) => open(OrderCancelationDrawer, props),
  };
};
